var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"margin-top":"0"}},[_vm._v("404 Not Found")]),_c('p',[_c('a',{attrs:{"href":"/#/login"}},[_vm._v("返回首页")])])])}]

export { render, staticRenderFns }